import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { useLocalizeMessage, Table, Badge, H5, Text } from 'libs.nucleus';
import { getStatusBadgeVariant, getStatusLabel } from '../../utils';
export const CloneDashboardSelect = ({ dashboards, isLoading, selectedDashboardId, onDashboardSelect, }) => {
    const translate = useLocalizeMessage();
    const cloneableDashboards = useMemo(() => dashboards.filter((d) => d.active !== false && d.status === 'PUBLISHED'), [dashboards]);
    const columns = useMemo(() => [
        {
            header: translate('Name'),
            accessorKey: 'name',
            cell: ({ row }) => (_jsx(Text, { size: 'sm', className: 'text-primary-500 font-medium', children: row.original.name })),
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (row) => row.data?.description || '',
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            cell: ({ row }) => _jsx(Badge, { label: `V${row.original.version}` }),
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            cell: ({ row }) => {
                const { status } = row.original;
                return _jsx(Badge, { label: getStatusLabel(status, translate), variant: getStatusBadgeVariant(status) });
            },
        },
    ], [translate]);
    // Reset selection if selected dashboard is no longer in the list
    useEffect(() => {
        if (selectedDashboardId && !cloneableDashboards.find((d) => d.id === selectedDashboardId)) {
            onDashboardSelect(null);
        }
    }, [cloneableDashboards, selectedDashboardId, onDashboardSelect]);
    const emptyStateMessage = useMemo(() => {
        if (dashboards.length === 0) {
            return translate('No dashboards available for cloning. Go back and create one manually to get started.');
        }
        return translate('No dashboards found matching your search.');
    }, [dashboards.length, translate]);
    return (_jsxs("div", { className: 'flex flex-col size-full p-4', children: [_jsx(H5, { className: 'mb-4', children: translate('Select the dashboard you want to clone') }), _jsx(Table, { columns: columns, data: cloneableDashboards, isLoading: isLoading, hasPagination: true, initialPageSize: 10, paginationNavigationScreenReaderLabel: translate('Pagination navigation'), isSelectable: true, isSingleSelect: true, getRowId: (row) => row.id, selectedIds: selectedDashboardId ? [selectedDashboardId] : undefined, onRowSelectionChange: (ids) => onDashboardSelect(ids[0] || null), useInternalSearch: true, labelNoResults: emptyStateMessage })] }));
};
